<mat-tab-group
  [selectedIndex]="selectedTab"
  [dynamicHeight]="true"
  animationDuration="0"
  (selectedIndexChange)="selectedIndexChange($event)"
  (animationDone)="animationDone()">
  <mat-tab>
    <ng-template matTabLabel><span translate="parameters/alcmeon-ai/tab/agents"></span></ng-template>
    <ng-template matTabContent>
      <ng-container *ngIf="showTabContent">
        <app-ai-agents></app-ai-agents>
      </ng-container>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel><span translate="parameters/alcmeon-ai/tab/docs"></span></ng-template>
    <ng-template matTabContent>
      <ng-container *ngIf="showTabContent">
        <app-knowledge-documents></app-knowledge-documents>
      </ng-container>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel><span translate="parameters/alcmeon-ai/tab/setup"></span></ng-template>
    <ng-template matTabContent>
      <ng-container *ngIf="showTabContent">
        <app-ai-ssistant-setup></app-ai-ssistant-setup>
      </ng-container>
    </ng-template>
  </mat-tab>
</mat-tab-group>
